const getters = {
  getUnitManagers: state => state.unitManagersList,
  getProjectManagers: state => state.projectManagersList,
  getAccountManagers: state => state.accountManagersList,
  getAllocations: state => state.allocations,
  getAvailability: state => state.availability,
  getEmploymentTypes: state => state.employmentTypes,
  getEnglishLevels: state => state.englishLevels,
  getPaymentTypes: state => state.paymentTypes,
  getSeniorityLevels: state => state.seniorityLevels
}

const actions = {
  setUnitManagers ({ commit }, data) {
    commit('setUnitManagers', data)
  },
  setProjectManagers ({ commit }, data) {
    commit('setProjectManagers', data)
  },
  setAccountManagers ({ commit }, data) {
    commit('setAccountManagers', data)
  },
  setAllocations ({ commit }, data) {
    commit('setAllocations', data)
  },
  setAvailability ({ commit }, data) {
    commit('setAvailability', data)
  },
  setEmploymentTypes ({ commit }, data) {
    commit('setEmploymentTypes', data)
  },
  setEnglishLevels ({ commit }, data) {
    commit('setEnglishLevels', data)
  },
  setPaymentTypes ({ commit }, data) {
    commit('setPaymentTypes', data)
  },
  setSeniorityLevels ({ commit }, data) {
    commit('setSeniorityLevels', data)
  }
}

const mutations = {
  setUnitManagers (state, data) {
    state.unitManagersList = data
  },
  setProjectManagers (state, data) {
    state.projectManagersList = data
  },
  setAccountManagers (state, data) {
    state.accountManagersList = data
  },
  setAllocations (state, data) {
    state.allocations = data
  },
  setAvailability (state, data) {
    state.availability = data
  },
  setEmploymentTypes (state, data) {
    state.employmentTypes = data
  },
  setEnglishLevels (state, data) {
    state.englishLevels = data
  },
  setPaymentTypes (state, data) {
    state.paymentTypes = data
  },
  setSeniorityLevels (state, data) {
    state.seniorityLevels = data
  }
}

const state = {
  unitManagersList: [],
  projectManagersList: [],
  accountManagersList: [],
  allocations: [],
  availability: [],
  employmentTypes: [],
  englishLevels: [],
  paymentTypes: [],
  seniorityLevels: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
